<div class="d-flex justify-content-between mb-2">
  <div>
    Gửi email: 
    <i class="fas fa-check text-success"  *ngIf="schedule.isSendEmail; else isNotSendEmail"></i>
    <ng-template #isNotSendEmail>
      <i class="fas fa-times text-danger"></i>
    </ng-template>
  </div>
  <div>
    Hoàn tất gửi email: 
    <i class="fas fa-check text-success"  *ngIf="isCompleteSendEmail; else isNotCompleteSendEmail"></i>
    <ng-template #isNotCompleteSendEmail>
      <i class="fas fa-times text-danger"></i>
    </ng-template>
  </div>
  <div>
    Gửi sms: 
    <i class="fas fa-check text-success"  *ngIf="schedule.iSendSMS; else isNotSendSms"></i>
    <ng-template #isNotSendSms>
      <i class="fas fa-times text-danger"></i>
    </ng-template>
  </div>
  <div>
    Hoàn tất gửi sms: 
    <i class="fas fa-check text-success"  *ngIf="isCompleteSendSms; else isNotCompleteSendSms"></i>
    <ng-template #isNotCompleteSendSms>
      <i class="fas fa-times text-danger"></i>
    </ng-template>
  </div>
</div>
<h5 class="mt-3">Tham dự</h5>
<div class="table-responsive">
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th scope="col" style="width: 60px">STT</th>
        <th scope="col">Phòng ban</th>
        <th scope="col">Người nhận</th>
        <th scope="col" class="text-center" style="width: 100px">Email</th>
        <th scope="col" class="text-center" style="width: 100px">SMS</th>
        <!-- <th scope="col" class="text-center" style="width: 100px">Gửi lại</th> -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of participants; let i = index">
        <th scope="row">{{ i + 1 }}</th>
        <td>{{ item.departmentName }}</td>
        <td>{{ item.fullName }}</td>
        <td class="text-center">
          <span class="badge bg-success" *ngIf="item.sendEmailIsSuccess; else sendFalsed">
            <i class="fas fa-check text-white"></i>
          </span>
          <ng-template #sendFalsed>
            <span class="badge bg-danger">
              <i class="fas fa-times text-white"></i>
            </span>
          </ng-template>
        </td>
        <td class="text-center">
          <span class="badge bg-success" *ngIf="item.sendSmsIsSuccess; else sendFalsed">
            <i class="fas fa-check text-white"></i>
          </span>
          <ng-template #sendFalsed>
            <span class="badge bg-danger">
              <i class="fas fa-times text-white"></i>
            </span>
          </ng-template>
        </td>
        <!-- <td class="text-center">
          <button class="btn btn-primary btn-sm">
            <i class="fas fa-envelope-open-text"></i>
          </button>
        </td> -->
      </tr>
    </tbody>
  </table>
</div>

<h5 class="mt-3">Thành phần tham dự khác</h5>
<div class="table-responsive">
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th scope="col" style="width: 60px">STT</th>
        <th scope="col">Người nhận</th>
        <th scope="col" class="text-center" style="width: 100px">Email</th>
        <th scope="col" class="text-center" style="width: 100px">SMS</th>
        <!-- <th scope="col" class="text-center" style="width: 100px">Gửi lại</th> -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of otherParticipant; let i = index">
        <th scope="row">{{ i + 1 }}</th>
        <td>{{ item.fullName }}</td>
        <td class="text-center">
          <span class="badge bg-success" *ngIf="item.sendEmailIsSuccess; else sendEmailFalsed">
            <i class="fas fa-check text-white"></i>
          </span>
          <ng-template #sendEmailFalsed>
            <span class="badge bg-danger">
              <i class="fas fa-times text-white"></i>
            </span>
          </ng-template>
        </td>
        <td class="text-center">
          <span class="badge bg-success" *ngIf="item.sendSmsIsSuccess; else sendFalsed">
            <i class="fas fa-check text-white"></i>
          </span>
          <ng-template #sendFalsed>
            <span class="badge bg-danger">
              <i class="fas fa-times text-white"></i>
            </span>
          </ng-template>
        </td>
        <!-- <td class="text-center">
          <button class="btn btn-primary btn-sm">
            <i class="fas fa-envelope-open-text"></i>
          </button>
        </td> -->
      </tr>
    </tbody>
  </table>
</div>